import { isPublishable } from './publication';

function instant(value, label) {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,3})?Z$/.test(value) || !isPublishable({}, value)) {
    throw new Error(`Invalid campaign ${label}: use an explicit valid UTC timestamp`);
  }
  return Date.parse(value);
}

// Shared eligibility; planned dates never claim actual first publication.
export function getCampaignEntries(entries, config, options = {}) {
  const days = new Set();
  const paths = new Set();
  for (const entry of entries) {
    if (!Number.isInteger(entry.day) || entry.day < 1 || entry.day > 15) throw new Error('Invalid campaign day');
    if (days.has(entry.day) || paths.has(entry.path)) throw new Error('Duplicate campaign day or path');
    if (typeof entry.path !== 'string' || !/^\/[a-z0-9/-]+$/.test(entry.path)) throw new Error('Invalid campaign path');
    days.add(entry.day); paths.add(entry.path);
  }
  const ordered = [...entries].sort((a, b) => a.day - b.day);
  if (options.preview === true) return ordered.map(entry => ({ ...entry }));
  if (config?.status !== 'scheduled' || config.approved !== true) return [];
  const start = instant(config.startAt, 'startAt');
  const cutoff = instant(options.asOf, 'cutoff');
  return ordered.map(entry => ({
    ...entry,
    publishAt: new Date(start + (entry.day - 1) * 86400000).toISOString(),
  })).filter(entry => Date.parse(entry.publishAt) <= cutoff);
}
